import { css, cx } from "@emotion/css"

import ImageButton from "../../html/ImageButton"

import closeImage from "./close.svg"

const CloseButton = ({ onClick, className }: JSX.IntrinsicElements["button"]) => {
  return (
    <ImageButton
      className={cx(styles.closeButton, className)}
      hoverClassName={styles.hover}
      onClick={onClick}
      src={closeImage}
      alt="閉じる"
    />
  )
}

export default CloseButton

const styles = {
  closeButton: css`
    background-color: #ffffff;
  `,
  hover: css`
    opacity: 0.7;
  `,
}
